import React from 'react';

const StatsCounter = () => {
  const stats = [
    { id: 1, count: '150+', label: 'Projects Completed', icon: 'fa-check-circle' },
    { id: 2, count: '100+', label: 'Global Clients', icon: 'fa-globe' },
    { id: 3, count: '15+', label: 'Expert Developers', icon: 'fa-users' },
    { id: 4, count: '99%', label: 'Client Satisfaction', icon: 'fa-heart' },
  ];

  return (
    <section className="py-20 bg-[#0A1D37] relative overflow-hidden">
      {/* Decorative Brand Accent */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#D62828] to-transparent opacity-50"></div>
      
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-6">
          {stats.map((stat) => (
            <div key={stat.id} className="text-center group">
              {/* Icon with Crimson Pulse */}
              <div className="inline-flex items-center justify-center w-16 h-16 mb-6 rounded-full bg-white/5 border border-white/10 group-hover:border-[#D62828] transition-colors duration-500">
                <i className={`fas ${stat.icon} text-2xl text-[#D62828]`}></i>
              </div>
              
              {/* Count */}
              <h3 className="text-4xl md:text-5xl font-black text-white mb-2 tracking-tighter">
                {stat.count}
              </h3>
              
              {/* Label */}
              <p className="text-slate-400 uppercase tracking-[0.2em] text-[10px] font-bold">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Subtle Background Watermark */}
      <div className="absolute -bottom-10 -right-10 text-[15rem] font-black text-white/[0.02] select-none pointer-events-none">
        ET
      </div>
    </section>
  );
};

export default StatsCounter;